export default "__VITE_ASSET__CqtCaA2K__"